import { useState } from "react";
import axios from "axios";

interface UseSendToBubbleParams {
    session: string;
}

export const useProcessDataBubble = (endpoint: string) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [response, setResponse] = useState<any>(null);

    const processData = (params: UseSendToBubbleParams) => {
        setIsLoading(true);
        setError(null);

        axios.post(endpoint, params)
            .then((res) => {
            setResponse(res.data);
            })
            .catch((err) => {
            setError(err.message || "An error occurred");
            })
            .finally(() => {
            setIsLoading(false);
            });
    };

    return { processData, isLoading, error, response };
};